<!-- src/views/InterviewCompleted.vue -->
<template>
  <div class="interview-completed">
    <h2>恭喜您成功完成面试</h2>
    <p>可前往面试列表查看面试记录</p>
    <el-button type="primary" @click="goBack">返回面试页</el-button>
  </div>
</template>

<script>
export default {
  methods: {
    goBack() {
      this.$router.push('/interview'); // 根据实际路由路径进行调整
    }
  }
};
</script>

<style scoped>
.interview-completed {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

h2 {
  font-size: 24px;
  margin-bottom: 20px;
}

p {
  font-size: 18px;
  margin-bottom: 30px;
}

.el-button {
  padding: 15px 30px;
  font-size: 18px;
}
</style>